var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeHeroArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "10 10 85 85",
    preserveAspectRatio: "none",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.57 10L42.53 19.04L66.32 45.57H12V59.22H67.83L39.51 84.61L48.54 94.79L93 54.75L52.57 10Z",
    fill: "#dddddd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeHeroArrow);
export default __webpack_public_path__ + "static/media/home-hero-arrow.9e1308ccc1484623e52a5bc96bf5a577.svg";
export { ForwardRef as ReactComponent };